/*
    Controller to launch the dialog used to create a factory devicegroup.

    The dialog allows the user to input a name for the to-be-created factory devicegroup,
    as well as select which production devicegroup will be it's Target Production Device Group.
    Usage:
        var globalCh = Radio.channel('global');
        globalCh.request('show_factory_device_group_settings_dialog', product);
    Arguments:
        product: Instance of v5 "product" model public/js/models/v5/product.js against which you want
            to create a new production devicegroup.
*/

import Radio from 'backbone.radio';
import FactoryDevicegroupDialog from '@/views/dialogs/factory_device_group_settings';
import PaginationControls from '@/views/pagination_controls';

    export default function show_create_factory_devicegroup(product, type) {
        let globalCh = Radio.channel('global');
        let apiCh = Radio.channel('api');
        let production_target_type = 'production_devicegroup';
        let dut_target_type = 'dut_devicegroup';

        if (type === 'pre_factoryfixture_devicegroup') {
            production_target_type = 'pre_production_devicegroup';
            dut_target_type = 'pre_dut_devicegroup';
        }

        let production_devicegroups = apiCh.request(production_target_type);
        let dut_devicegroups = apiCh.request(dut_target_type);
        let production_pagination_controls = new PaginationControls({
            collection: production_devicegroups
        });
        let dut_pagination_controls = new PaginationControls({
            collection: dut_devicegroups
        });

        var factory_devicegroup_dialog = new FactoryDevicegroupDialog({
            production_pagination_controls: production_pagination_controls,
            dut_pagination_controls: dut_pagination_controls,
            devicegroups: production_devicegroups,
            dut_devicegroups: dut_devicegroups,
            product: product,
            type: type,
            production_target_type: production_target_type,
            dut_target_type: dut_target_type
        });

        var calls = [];
        calls.push(production_devicegroups.fetch({
            remove: false,
            data: {
                'filter[type]': production_target_type,
                'filter[product.id]': product.id,
                'sort':'-deployment'
            }
        }));
        calls.push(dut_devicegroups.fetch({
            remove: false,
            data: {
                'filter[type]': dut_target_type,
                'filter[product.id]': product.id,
                'sort':'-deployment'
            }
        }));

        Promise.all(calls).then( () => {
            production_pagination_controls.update_prev_next_from_response;
            dut_pagination_controls.update_prev_next_from_response;
            globalCh.request('showDialog', factory_devicegroup_dialog);
        }
        ).catch(console.error);


    }

